export default __webpack_public_path__ + "static/media/akash-network-logo.cd5d4770.png";